<template>
  <AtomsConsumerLink :url="`${articleType === 'news' ? `/news/${journal.slug}` : journalPath}`">
    <article :class="[`${gtmClass ? gtmClass : ''}`, $style.journal_list_item]">
      <div :class="$style.thumbnail">
        <AtomsConsumerImage :src="journal.thumbnail_image ?? ''" :alt="journal.title" :width="400" :height="300" />
      </div>
      <p :class="$style.title">{{ journal.title }}</p>
      <p v-if="!createdDataHidden" :class="$style.date">
        {{ formatDate(journal.created_unixtime) }}
      </p>
      <div v-if="isJournalFragmentType && journal.product_category" :class="$style.icon_area">
        <span> # {{ journal.product_category?.name }} </span>
      </div>
    </article>
  </AtomsConsumerLink>
</template>

<script setup lang="ts">
import { formatDate } from "@tential/ec-gql-schema/utils/functions/date"
import type { JournalListItemType } from "~/types/journal"

const props = defineProps({
  articleType: {
    type: String,
    required: false,
    default: "",
  },
  journal: {
    type: Object as PropType<JournalListItemType>,
    required: true,
  },
  createdDataHidden: {
    type: Boolean,
    required: false,
    default: false,
  },
  gtmClass: {
    type: String,
    required: false,
    default: "",
  },
})

const isJournalFragmentType = computed(() => {
  return !!props.journal.product_category || !!props.journal.slug
})

const journalPath = computed(() => {
  const { slug, product_category, product_sub_category } = props.journal
  return isJournalFragmentType.value ? `/journals/${product_category?.slug}/${product_sub_category?.slug}/${slug}` : ""
})
</script>

<style module scoped lang="scss">
.journal_list_item {
  .thumbnail {
    aspect-ratio: 4 / 3;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.5rem;
    }
  }
  .icon_area {
    display: flex;
    align-items: center;
    color: $primary;
    margin-top: 0.5rem;
    span {
      font-size: $font-size-14;
      border-bottom: 1px solid $primary;
    }
  }
  .title {
    @include main-font;
    padding: 1rem 0 0.5rem;
    font-size: $font-size-16;
    color: $primary;
  }
}
</style>
